import { render, staticRenderFns } from "./NarocilaCakalanaVrsta.vue?vue&type=template&id=58c31e6e&"
import script from "./NarocilaCakalanaVrsta.vue?vue&type=script&lang=js&"
export * from "./NarocilaCakalanaVrsta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports